import { useLocation } from "react-router-dom";

export const useBackUrl = () => {
  const locationPathname = useLocation().pathname;
  return locationPathname.substring(0, locationPathname.lastIndexOf("/"));
};
